import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import {
  useTreatmentQuery,
  useTreatmentQuery$data,
} from "@/modules/admin/treatment/services/__generated__/useTreatmentQuery.graphql"

const treatmentQuery = graphql`
  query useTreatmentQuery {
    allMyTreatmentPlanTemplates {
      id
      countries
      name
      languages {
        language
        synonym
        title
      }
    }
  }
`

const useTreatmentQueryLoader = () => {
  return useQueryLoader<useTreatmentQuery>(treatmentQuery)
}

export { treatmentQuery, useTreatmentQueryLoader }

type TreatmentQueryResult = useTreatmentQuery$data["allMyTreatmentPlanTemplates"][0]
export type TreatmentPlanItem = Pick<TreatmentQueryResult, "id" | "name" | "countries"> & {
  title: string
  synonym: string
}
